const PLANOS = {
    STANDARD: 1,
    ADVANCED: 2,
    EXCLUSIVE: 3
};

export { PLANOS };
